// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__10X2C","subTitle":"select_subTitle__ez2m1","borderLess":"select_borderLess__GYdNi","borderError":"select_borderError__14jJF","error":"select_error__379D0"};